import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { currentCategorySelector, isAllSwagSelector, descriptionTitleSelector, descriptionTextSelector, isDescriptionBlockShownSelector, isDescriptionBlockOpenSelector } from '../../../../../../redux/product-listing/product-listing.selectors';
import { isCuratedBrandStoreSelector } from '../../../../../../redux/curated-brand-store/curated-brand-store-other.selector';
import { CategoryDescription as CategoryDescriptionComponent } from './category-description';
const mapStateToProps = createStructuredSelector({
  currentCategory: currentCategorySelector,
  descriptionTitle: descriptionTitleSelector,
  descriptionText: descriptionTextSelector,
  isDescriptionBlockShown: isDescriptionBlockShownSelector,
  isDescriptionBlockOpen: isDescriptionBlockOpenSelector,
  isAllSwag: isAllSwagSelector,
  isCuratedBrandStore: isCuratedBrandStoreSelector
});
export const CategoryDescription = connect(mapStateToProps)(CategoryDescriptionComponent);